import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { shallow } from '@jwp/ott-common/src/utils/compare';
import { getModule } from '@jwp/ott-common/src/modules/container';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
import FavoritesController from '@jwp/ott-common/src/controllers/FavoritesController';
import useBreakpoint from '@jwp/ott-ui-react/src/hooks/useBreakpoint';

import { useFavoritesStore } from '@jwp/ott-common/src/stores/FavoritesStore';

import ConfirmationDialog from '../../components/ConfirmationDialog/ConfirmationDialog';
import Favorites from '../../components/Favorites/Favorites';
import LoadingOverlay from '../../components/LoadingOverlay/LoadingOverlay';

import styles from './FavouritesPage.module.scss';

const FavouritesPage = (): JSX.Element => {
  const favoritesController = getModule(FavoritesController);
  const [clearFavoritesOpen, setClearFavoritesOpen] = useState(false);
  const { accessModel, favoritesList } = useConfigStore(
    (s) => ({
      accessModel: s.accessModel,
      favoritesList: s.config.features?.favoritesList,
    }),
    shallow,
  );
  const navigate = useNavigate();

  const breakpoint = useBreakpoint();
  const { t } = useTranslation('user');

  const { user: customer, subscription, loading } = useAccountStore();

  const favorites = useFavoritesStore((state) => state.getPlaylist());

  useEffect(() => {
    if (!loading && !customer) {
      navigate('/', { replace: true });
    }
  }, [navigate, customer, loading]);

  if (!customer) {
    return (
      <div className={styles.user}>
        <LoadingOverlay inline />
      </div>
    );
  }

  return (
    <div className={styles.favouriteContainer}>
      <Favorites playlist={favorites} onClearFavoritesClick={() => setClearFavoritesOpen(true)} accessModel={accessModel} hasSubscription={!!subscription} />
      <ConfirmationDialog
        open={clearFavoritesOpen}
        title={t('favorites.clear_favorites_title')}
        body={t('favorites.clear_favorites_body')}
        onConfirm={async () => {
          await favoritesController.clear();
          setClearFavoritesOpen(false);
        }}
        onClose={() => setClearFavoritesOpen(false)}
      />
    </div>
  );
};

export default FavouritesPage;
